export default __webpack_public_path__ + "img/tiny-18.4091d469.jpg";